import React from 'react'
import styled from 'styled-components';

const LdsDualRingContainer = styled.div`
    display: flex;
    align-items: center;
    width: 80px;
    height: 80px;
    position: relative;
`;

const LdsDualRing = styled.div` 
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    border-radius: 50%;
    border: 3px solid #000;
    border-color: #121180 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const AamerLogoImg = styled.img`
    position: absolute;
    left: 28px;
    width: 35px;
    height: auto;
`;

const AamerLoader = ({ color = '#121180', style, size = 90 }) => (
    <LdsDualRingContainer style={{ width: size, height: size, ...style }}>
        <LdsDualRing style={{
            borderColor: `${color} transparent`,
            borderWidth: size/2 * 0.1,
            width: size * 0.7 - 6,
            height: size * 0.7 - 6,
        }} />
        <AamerLogoImg src={'/Assets/amrTransLogo.png'} alt={'Aamer Logo'} />
    </LdsDualRingContainer>
);

export default AamerLoader;